export function getMatchingSubstring(string, startIndex) {
    let start = startIndex;
    while (start >= 0 && string[start] !== ' ') {
        start--;
    }
    let end = startIndex;
    while (end < string.length && string[end] !== ' ') {
        end++;
    }
    return string.substring(start + 1, end);
}
